import axios from 'axios';
import { getCookie } from 'cookies-next';
import { TYPE_CONSTANT } from '../constant/Web_constant';

export const updateUserLocale = async (locale) => {
  const userDetails = JSON.parse(localStorage.getItem('user_details'));
  const auth_key = getCookie(`${TYPE_CONSTANT.DOMAIN}_auth_key`);
  if (userDetails && auth_key) {
    try {
      const userData = {
        user: {
          locale: locale,
        },
      };
      await axios.post('/api/user/update_user', {
        userId: userDetails.id,
        userData,
      });
    } catch (error) {
      console.error('Error updating user locale:', error);
    }
  }
};
